import {Component, inject, Input, OnChanges, SimpleChanges} from '@angular/core';
import {Attachment} from "../../../store/entities/shared/attachment.model";
import {AttachmentService} from "../../../services/attachment.service";

@Component({
  selector: 'app-attachment-chip',
  templateUrl: './attachment-chip.component.html',
  styleUrl: './attachment-chip.component.scss'
})
export class AttachmentChipComponent implements OnChanges {

  @Input()
  attachment: Attachment;

  @Input()
  attachmentObject: any;

  attachmentService: AttachmentService = inject(AttachmentService);

  isLoading: boolean;

  ngOnChanges(changes: SimpleChanges): void {
    if (changes?.['attachmentObject']) {
      this.attachment = {
        ...this.attachment,
        fileName: this.attachmentObject?.name,
        filePath: this.attachmentObject?.path,
      }
    }
  }

  getAttachmentIcon(): 'pdf2' | 'doc' | 'mp3' | 'mp4' | 'image' {
    let nameArray = this.attachment?.fileName?.split('.');
    let iconName: 'pdf2' | 'doc' | 'mp3' | 'mp4' | 'image'
    if (nameArray?.[nameArray?.length - 1] === 'pdf') {
      iconName = 'pdf2'
    } else if (nameArray?.[nameArray?.length - 1] === 'jpg' || nameArray?.[nameArray?.length - 1] === 'png') {
      iconName = 'image'
    } else {
      iconName = nameArray?.[nameArray?.length - 1] as 'pdf2' | 'doc' | 'mp3' | 'mp4'
    }
    return ['pdf2', 'doc', 'mp3', 'mp4', 'image']?.includes(iconName) ? iconName : 'doc'
  }

  async openAttachment() {
    this.isLoading = true;
    try {
      let fileType: any = 'DOC'
      switch (this.getAttachmentIcon()) {
        case "pdf2":
          fileType = 'PDF'
          break
        case 'mp3':
          fileType = 'VIDEO'
          break
        case "mp4":
          fileType = 'VIDEO'
          break
        case "image":
          fileType = 'IMAGE'
          break
      }

      const response = await this.attachmentService.readAttachment(this.attachment.filePath);
      if (fileType !== 'DOC') {
        await this.attachmentService.viewPdfInModal(response.base64String, this.attachment.fileName, '80%', fileType);
      } else {
        let nameArray = this.attachment?.fileName?.split('.');
        const attachmentIcon = nameArray?.[nameArray?.length - 1];
        if (attachmentIcon === 'xlsx' || attachmentIcon === 'xls') {
          const link = document.createElement('a');
          link.download = response?.fileName;
          link.href = 'data:application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64,' + response.base64String;
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        } else if (attachmentIcon === 'doc' || attachmentIcon === 'docx') {
          const link = document.createElement('a');
          link.download = response?.fileName;
          link.href = 'data:application/vnd.openxmlformats-officedocument.wordprocessingml.document;base64,' + response.base64String;
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        }
      }
    } catch (e) {}
    this.isLoading = false;
  }

}
